import React from 'react';

export default function Spinner() {
  return (
    <article>
      <img src="https://media4.giphy.com/media/l3q2Okm6SwPwXZqp2/giphy.gif?cid=ecf05e47ww5pd3omcsxf2vu2ni2rw3dx2h21lbk614a8yivs&rid=giphy.gif&ct=g" />
    </article>
  );
}
